import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatTableDataSource } from '@angular/material/table';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { LmsService } from "../../_Lms/services/lms.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { DialogService } from "../../Shared/dialog.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
declare var $: any;

@Component({
  selector: 'app-multiple-general-voucher-import',
  templateUrl: './multiple-general-voucher-import.component.html',
  styleUrls: ['./multiple-general-voucher-import.component.scss']
})
export class MultipleGeneralVoucherImportComponent implements OnInit {
  mode: 'LoanToAccount' | 'ReceiptLoan' |
    'PaymentLoanToAccount' |
    'PartnerReceipt' | 'PartnerPayment' |
    'PartnerJournalLoanToAccount' = 'LoanToAccount';
  Voucher_Tag: any = 'CASH';
  accountTagDropdown: any = [];
  showSpinner: boolean = false;
  ChargesHeadDropdown: any = [];
  accountHeadDropdown: any = [];
  DRAccountId: any = '';
  Voucher_Mode_of_Payment: any = '';
  Voucher_E_Ref_No: any = '';
  Voucher_E_Transaction_Date: any = '';
  Voucher_Cheque_No: any = '';
  Voucher_Cheque_Date: any = '';
  Voucher_Cheque_Clear_Date: any = '';
  Voucher_Bank_Name: any = '';
  Account_HeadId: any = '';
  Amount: any;
  UnmatchedData: any[] = [];
  UIValidationFailed: any[] = [];
  displayedColumnsUIValidation: string[] = [];
  dataSourceUIValidation: any;
  VoucherDate: any;
  ToDate = new Date();
  Type: any = "CR"
  UnmatcheddisplayedColumns: string[] = [];
  dataSourceUnmatched: any;
  currentUser: any;
  configSuccess: MatSnackBarConfig = {
    panelClass: 'style-success',
    duration: 5000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  };

  voucherMasterdata: any;
  voucherDetaildata: any;
  dataSourceVoucher: any;
  displayedVoucherColumns: string[] = [];
  displayedAccountingColumns: string[] = [];   // for AccountToAccount preview
  Remarks: any;
  MainPayload: any;
  BranchesList: any = [];
  BranchId: any = '';
  @ViewChild('bulkImportModel') bulkImportModel: any;
  @ViewChild('importFileInput') importFileInput!: ElementRef;
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    private _MasterService: MasterService,
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private dialogService: DialogService,
    private lmsService: LmsService
  ) { }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Multiple General Voucher Import");
    this._MasterService.GetProductChargesHeadDropDown().subscribe((result) => {
      this.ChargesHeadDropdown = JSON.parse(JSON.stringify(result));
    });
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.Get_Acc_Accounts_OtherThan_BankCash();
    this.getBranchesList();
    this.Get_Acc_Accounts_By_Tag();
  }
  get modalTitle(): string {
    switch (this.mode) {
      case 'ReceiptLoan':
        return 'Receipt Loan Import';
      case 'PaymentLoanToAccount':
        return 'Payment Loan to Account Import';
      case 'PartnerReceipt':
        return 'Partner Receipt Voucher Import';
      case 'PartnerPayment':
        return 'Partner Payment Voucher Import';
      case 'PartnerJournalLoanToAccount':
        return 'Partner Journal Loan to Account Import';
      default:
        return 'Loan to Accounts Import';
    }
  }

  getBranchesList() {
    this.lmsService.GetBranches({ Emp_Id: this.currentUser.userId }).subscribe((result) => {
      this.BranchesList = JSON.parse(JSON.stringify(result));
    });
  }

  Get_Acc_Accounts_OtherThan_BankCash() {
    this.lmsService.Get_Acc_Accounts_ForJVandContra({ IsJournal: 1, isAccounting: 0 }).subscribe((res: any) => {
      this.accountHeadDropdown = res;
    });
  }

  Get_Acc_Accounts_By_Tag() {
    this.lmsService
      .Get_Acc_Accounts_By_Tag({
        LoginUserId: this.currentUser.userId,
        Account_Tag: this.Voucher_Tag,
        Voucher_Date: this.VoucherDate || new Date(),
      })
      .subscribe((res: any) => {
        this.accountTagDropdown = res;
      });
  }

  // ======================= EXPORT EXCEL =======================
  exportExcel(mode: 'LoanToAccount' | 'ReceiptLoan' | 'PaymentLoanToAccount' | 'PartnerReceipt' | 'PartnerPayment' | 'PartnerJournalLoanToAccount') {
    this.mode = mode;
    if (!this.ChargesHeadDropdown || this.ChargesHeadDropdown.length === 0) {
      this.snackBar.open('Charges Head not loaded yet!', 'Close', { duration: 3000 });
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const sheet1 = workbook.addWorksheet('Sheet1');
    if (mode === 'PaymentLoanToAccount' || mode === 'ReceiptLoan' || mode === 'PartnerReceipt' || mode === 'PartnerPayment') {
      // Loan-based receipt/payment with per-row payment details
      const chargesSheet = workbook.addWorksheet('ChargesHead');
      chargesSheet.addRow(['Id', 'Charges Head Name']);
      this.ChargesHeadDropdown.forEach((item: any) => {
        chargesSheet.addRow([item.Id, item.ChagesHead]);
      });
      // Columns: LoanNo, Amount, ChargesHeadId, PaymentMode, RefNo, Voucher_Narration
      sheet1.addRow(['LoanNo', 'Amount', 'ChargesHeadId', 'PaymentMode', 'RefNo', 'Voucher_Narration']);
      // Data validation for ChargesHeadId
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`ChargesHead!$B$2:$B$${this.ChargesHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Charges Head',
          error: 'Please select from dropdown'
        };
      }
      // Data validation for PaymentMode (list of allowed modes)
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`D${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: ['"CASH,Bank,Cheque,RTGS,NEFT,IMPS,Transfer"'],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Payment Mode',
          error: 'Please select a valid mode'
        };
      }
      chargesSheet.state = 'hidden';
    }
    else { // LoanToAccount + PartnerJournalLoanToAccount
      const chargesSheet = workbook.addWorksheet('ChargesHead');
      chargesSheet.addRow(['Id', 'Charges Head Name']);
      this.ChargesHeadDropdown.forEach((item: any) => {
        chargesSheet.addRow([item.Id, item.ChagesHead]);
      });
      // Add Voucher_Narration column
      sheet1.addRow(['LoanNo', 'Amount', 'ChargesHeadId', 'Voucher_Narration']);
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`ChargesHead!$B$2:$B$${this.ChargesHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Value',
          error: 'Please select from dropdown only'
        };
      }
      chargesSheet.state = 'hidden';
    }

    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      let fileName = '';
      if (mode === 'ReceiptLoan') fileName = 'ReceiptLoan_Import.xlsx';
      else if (mode === 'PaymentLoanToAccount') fileName = 'PaymentLoanToAccount_Import.xlsx';
      else if (mode === 'PartnerReceipt') fileName = 'PartnerReceipt_Import.xlsx';
      else if (mode === 'PartnerPayment') fileName = 'PartnerPayment_Import.xlsx';
      else if (mode === 'PartnerJournalLoanToAccount') fileName = 'PartnerJournalLoanToAccount_Import.xlsx';
      else fileName = 'GeneralVoucher_Import.xlsx';
      saveAs(blob, fileName);
    });
  }

  OpenModel(mode: 'LoanToAccount' | 'ReceiptLoan' | 'PaymentLoanToAccount' | 'PartnerReceipt' | 'PartnerPayment' | 'PartnerJournalLoanToAccount') {
    this.mode = mode;
    this.resetValidation();
    this.VoucherDate = null;
    this.Remarks = '';
    this.BranchId = '';
    this.Voucher_Tag = '';
    this.DRAccountId = '';
    this.Voucher_Mode_of_Payment = '';
    this.Voucher_Cheque_No = '';
    this.Voucher_Cheque_Date = null;
    this.Voucher_Cheque_Clear_Date = null;
    this.Voucher_Bank_Name = '';
    this.Voucher_E_Ref_No = '';
    this.Voucher_E_Transaction_Date = null;

    if (mode === 'LoanToAccount' || mode === 'PartnerJournalLoanToAccount') {
      this.Account_HeadId = '';
      this.Type = 'CR';
      this.BranchId = '';
    }


    $("#bulkImportModel").modal("show");
    $("#bulkImportModel").css("z-index", "1050");
  }

  onClose() {
    $("#bulkImportModel").modal("hide");
  }

  // ======================= IMPORT EXCEL =======================
  async importExcel(event: any) {
    this.resetValidation();

    const file = event.target.files[0];
    if (!file) return;

    const workbook = new ExcelJS.Workbook();
    const buffer = await file.arrayBuffer();
    await workbook.xlsx.load(buffer);

    const sheet = workbook.getWorksheet('Sheet1');
    if (!sheet) {
      this.snackBar.open('Sheet1 not found!', 'Close', { duration: 3000 });
      return;
    }

    let rawData: any[] = [];

    if (this.mode === 'ReceiptLoan' || this.mode === 'PaymentLoanToAccount' ||
      this.mode === 'PartnerReceipt' || this.mode === 'PartnerPayment') {
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;
        const loanNo = row.getCell(1).value?.toString().trim() || '';
        const amount = row.getCell(2).value;
        const chargesHeadName = row.getCell(3).value;
        const paymentMode = row.getCell(4)?.value?.toString().trim() || '';
        const refNo = row.getCell(5)?.value?.toString().trim() || '';
        const narration = row.getCell(6)?.value?.toString().trim() || '';

        if (!loanNo && !amount && !chargesHeadName && !paymentMode && !refNo && !narration) return;

        const matched = this.ChargesHeadDropdown.find(
          (x: any) => x.ChagesHead?.toString().trim() === chargesHeadName?.toString().trim()
        );
        const rowData: any = {
          Id: rawData.length + 1,
          LoanNo: loanNo,
          Amount: String(amount || '').trim(),
          ChargesHead: String(chargesHeadName || '').trim(),
          ChargesHeadId: matched ? matched.Id : null,
          PaymentMode: paymentMode,
          RefNo: refNo,
          Voucher_Narration: narration
        };
        rawData.push(rowData);
      });
    }

    // else if (this.mode === 'LoanToLoan') {
    //   // Existing LoanToLoan parsing
    //   sheet.eachRow((row: any, rowNumber: number) => {
    //     if (rowNumber === 1) return;
    //     const loanNo = row.getCell(1).value;
    //     const amount = row.getCell(2).value;
    //     const chargesHeadName = row.getCell(3).value;
    //     const transType = row.getCell(4)?.value?.toString()?.toUpperCase() || '';
    //     if (!loanNo && !amount && !chargesHeadName && !transType) return;
    //     const matched = this.ChargesHeadDropdown.find(
    //       (x: any) => x.ChagesHead?.toString().trim() === chargesHeadName?.toString().trim()
    //     );
    //     const rowData: any = {
    //       Id: rawData.length + 1,
    //       LoanNo: String(loanNo || '').trim(),
    //       Amount: String(amount || '').trim(),
    //       ChargesHead: String(chargesHeadName || '').trim(),
    //       ChargesHeadId: matched ? matched.Id : null,
    //       TransType: transType
    //     };
    //     rawData.push(rowData);
    //   });
    // }
    // else if (this.mode === 'PartnerReceipt' || this.mode === 'PartnerPayment') {
    //   sheet.eachRow((row: any, rowNumber: number) => {
    //     if (rowNumber === 1) return;
    //     const partnerLoanNo = row.getCell(1).value?.toString().trim() || '';
    //     const amount = row.getCell(2).value;
    //     const chargesHeadName = row.getCell(3).value;

    //     if (!partnerLoanNo && !amount && !chargesHeadName) return;

    //     const matched = this.ChargesHeadDropdown.find(
    //       (x: any) => x.ChagesHead?.toString().trim() === chargesHeadName?.toString().trim()
    //     );
    //     const rowData: any = {
    //       Id: rawData.length + 1,
    //       LoanNo: partnerLoanNo,      // map Partner_LoanNo to LoanNo
    //       Amount: String(amount || '').trim(),
    //       ChargesHead: String(chargesHeadName || '').trim(),
    //       ChargesHeadId: matched ? matched.Id : null,
    //     };
    //     rawData.push(rowData);
    //   });
    // } 
    else { // LoanToAccount + PartnerJournalLoanToAccount
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;
        const loanNo = row.getCell(1).value;
        const amount = row.getCell(2).value;
        const chargesHeadName = row.getCell(3).value;
        const narration = row.getCell(4)?.value?.toString().trim() || ''; // Read Voucher_Narration

        if (!loanNo && !amount && !chargesHeadName) return;
        const matched = this.ChargesHeadDropdown.find(
          (x: any) => x.ChagesHead?.toString().trim() === chargesHeadName?.toString().trim()
        );
        const rowData: any = {
          Id: rawData.length + 1,
          LoanNo: String(loanNo || '').trim(),
          Amount: String(amount || '').trim(),
          ChargesHead: String(chargesHeadName || '').trim(),
          ChargesHeadId: matched ? matched.Id : null,
          Voucher_Narration: narration  // Add narration field
        };
        rawData.push(rowData);
      });
    }

    if (rawData.length === 0) {
      this.snackBar.openFromComponent(SnackbarComponent, { data: 'No data found in Excel file!', ...this.configSuccess });
      event.target.value = null;
      return;
    }

    this.UIValidationFailed = this.validateUIRows(rawData);

    if (this.UIValidationFailed.length > 0) {
      this.showUIValidationTable();
      const fileInput = document.getElementById('bulkImport') as HTMLInputElement;
      if (fileInput) fileInput.value = '';
    } else {
      this.processValidData(rawData);
    }

    event.target.value = null;
  }
  private validateUIRows(data: any[]): any[] {

    const allowedUnlimitedModes = ['PaymentLoanToAccount', 'PartnerPayment', 'PaymentAccountToAccount'];
    if (data.length > 50 && !allowedUnlimitedModes.includes(this.mode)) {
      this.snackBar.openFromComponent(SnackbarComponent, { data: 'Max row of data import is 50!', ...this.configSuccess });
      return data.map(row => ({
        ...row,
        maxRowLimitError: true
      }));
    }

    const failedRows: any[] = [];

    data.forEach((row) => {
      const errorFlags: any = {};
      if (this.mode === 'ReceiptLoan' || this.mode === 'PaymentLoanToAccount' ||
        this.mode === 'PartnerReceipt' || this.mode === 'PartnerPayment') {

        if (!row.LoanNo || row.LoanNo.trim() === '')
          errorFlags.loanNoError = true;

        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0)
          errorFlags.amountError = true;

        if (!row.ChargesHead || row.ChargesHead.trim() === '' || !row.ChargesHeadId)
          errorFlags.chargesHeadError = true;

        if (!row.PaymentMode)
          errorFlags.paymentModeError = true;

        // === NEW: RefNo Validation - Optional but must be UNIQUE if provided ===
        if (row.RefNo && row.RefNo.toString().trim() !== '') {
          const refNoValue = row.RefNo.toString().trim();

          const isDuplicate = data.some((r: any, index: number) => {
            // Skip current row
            if (index === data.indexOf(row)) return false;   // Better way using indexOf

            const otherRefNo = r.RefNo ? r.RefNo.toString().trim() : '';
            return otherRefNo !== '' &&
              otherRefNo.toLowerCase() === refNoValue.toLowerCase();
          });

          if (isDuplicate) {
            errorFlags.refNoDuplicateError = true;   // Better to use specific flag
          }
        }
      }
      else if (this.mode === 'LoanToAccount' || this.mode === 'PartnerJournalLoanToAccount') {
        if (!row.LoanNo || row.LoanNo.trim() === '') errorFlags.loanNoError = true;
        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0) errorFlags.amountError = true;
        if (!row.ChargesHead || row.ChargesHead.trim() === '' || !row.ChargesHeadId) errorFlags.chargesHeadError = true;
        // Voucher_Narration is optional - no validation required
      }
      if (Object.keys(errorFlags).length > 0) {
        failedRows.push({ ...row, ...errorFlags });
      }
    });

    return failedRows;
  }
  private showUIValidationTable() {
    if (this.mode === 'ReceiptLoan' || this.mode === 'PartnerReceipt') {
      this.displayedColumnsUIValidation = ["Id", "LoanNo", "Amount", "ChargesHead", "PaymentMode", "RefNo", "Voucher_Narration"];
    } else if (this.mode === 'LoanToAccount' || this.mode === 'PartnerJournalLoanToAccount') {
      this.displayedColumnsUIValidation = ["Id", "LoanNo", "Amount", "ChargesHead", "Voucher_Narration"];
    } else if (this.mode === 'PaymentLoanToAccount' || this.mode === 'PartnerPayment') {
      this.displayedColumnsUIValidation = ["Id", "LoanNo", "Amount", "ChargesHead", "PaymentMode", "RefNo"];
    }
    console.log("this.UIValidationFailed", this.UIValidationFailed);
    this.dataSourceUIValidation = new MatTableDataSource(this.UIValidationFailed);
    $("#bulkImportModel").modal("show");
  }

  private processValidData(data: any[]) {
    let JsonData: any;
    // Convert date to local string WITHOUT timezone shift
    const formatLocalDate = (date: any): string => {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const voucherDate = formatLocalDate(this.VoucherDate);
    if (this.mode === 'ReceiptLoan' || this.mode === 'PaymentLoanToAccount' ||
      this.mode === 'PartnerReceipt' || this.mode === 'PartnerPayment') {
      const finalData = data.map(row => ({
        LoanNo: row.LoanNo,
        Amount: Number(row.Amount),
        ChargesHeadId: row.ChargesHeadId,
        PaymentMode: row.PaymentMode,
        RefNo: row.RefNo || "",
        Voucher_Narration: row.Voucher_Narration || ""
      }));
      JsonData = {
        VoucherDate: voucherDate,
        AccountId: Number(this.DRAccountId),
        Voucher_Tag: this.Voucher_Tag,
        // Voucher_Narration: this.Remarks,
        LoanDetails: finalData
      };
    }
    else if (this.mode === 'LoanToAccount' || this.mode === 'PartnerJournalLoanToAccount') {
      const finalData = data.map(row => ({
        LoanNo: row.LoanNo,
        Amount: Number(row.Amount),
        ChargesHeadId: row.ChargesHeadId,
        Voucher_Narration: row.Voucher_Narration || ""
      }));
      JsonData = {
        VoucherDate: voucherDate,
        AccountId: Number(this.Account_HeadId),
        TransType: this.Type,
        BranchId: Number(this.BranchId),
        Voucher_Narration: this.Remarks,
        LoanDetails: finalData
      };
    }
    let checkApi;
    if (this.mode === 'ReceiptLoan') {
      checkApi = this._MasterService.Receipt_Voucher_Check_LoantoAccount_Import({
        JsonData: JSON.stringify(JsonData),
        IsMultipleVoucher: 1
      });
    } else if (this.mode === 'PaymentLoanToAccount') {
      checkApi = this._MasterService.Payment_Voucher_Check_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
    } else if (this.mode === 'PartnerReceipt') {
      checkApi = this._MasterService.Partner_Receipt_Voucher_Check_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
    }
    else if (this.mode === 'PartnerPayment') {
      checkApi = this._MasterService.Partner_Payment_Voucher_Check_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
    } else if (this.mode === 'PartnerJournalLoanToAccount') {
      checkApi = this._MasterService.Partner_Journal_Voucher_Check_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
    }
    else {
      checkApi = this._MasterService.Journal_Voucher_Check_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
    }


    checkApi.subscribe((res: any) => {
      if (res && res.length > 0) {
        // Map backend fields to what the template expects
        this.UnmatchedData = res.map((item: any) => ({
          ...item,
          AccountHead: item.AccountName || item.AccountHead || '',
          LoanNo: item.LoanNo || ''
        }));
        this.UnmatcheddisplayedColumns = ["Id", "LoanNo", "ErrorReason"
        ]; this.dataSourceUnmatched = new MatTableDataSource(this.UnmatchedData);
      } else {
        let getApi;
        if (this.mode === 'LoanToAccount') {
          getApi = this._MasterService.Journal_Voucher_Get_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
        } else if (this.mode === 'ReceiptLoan') {
          getApi = this._MasterService.Receipt_Voucher_Get_LoantoAccount_Import({
            JsonData: JSON.stringify(JsonData),
            IsMultipleVoucher: 1
          });
        }
        else if (this.mode === 'PaymentLoanToAccount') {
          getApi = this._MasterService.Payment_Voucher_Get_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
        } else if (this.mode === 'PartnerReceipt') {
          getApi = this._MasterService.Partner_Receipt_Voucher_Get_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
        }
        else if (this.mode === 'PartnerPayment') {
          getApi = this._MasterService.Partner_Payment_Voucher_Get_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
        } else if (this.mode === 'PartnerJournalLoanToAccount') {
          getApi = this._MasterService.Partner_Journal_Voucher_Get_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData), IsMultipleVoucher: 1 });
        }

        getApi.subscribe((res: any) => {
          this.voucherMasterdata = res.Item1[0];
          this.voucherDetaildata = res.Item2;

          this.voucherDetaildata.forEach((x: any) => {
            x.AmountDR = x.TranType === 'DR' ? x.Amount : 0;
            x.AmountCR = x.TranType === 'CR' ? x.Amount : 0;
          });
          this.dataSourceVoucher = new MatTableDataSource(this.voucherDetaildata);
          this.displayedVoucherColumns = [
            'Type', 'CaseNo', 'Customer', 'Branch', 'Category', 'AccountHead', 'AmountDR', 'AmountCR'
          ];

          this.MainPayload = JsonData;
          $("#voucherDetailModel").modal("show");
          $('#voucherDetailModel').css('z-index', '1051');
        });
      }
    });
  }

  OnSaveVoucher() {
    let saveApi;
    if (this.mode === 'LoanToAccount') {
      saveApi = this._MasterService.Journal_Voucher_Save_LoantoAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId, IsMultipleVoucher: 1 });
    }
    else if (this.mode === 'ReceiptLoan') {
      saveApi = this._MasterService.Receipt_Voucher_Save_LoantoAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId, IsMultipleVoucher: 1 });
    } else if (this.mode === 'PaymentLoanToAccount') {
      saveApi = this._MasterService.Payment_Voucher_Save_LoantoAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId, IsMultipleVoucher: 1 });
    } else if (this.mode === 'PartnerReceipt') {
      saveApi = this._MasterService.Partner_Receipt_Voucher_Save_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId, IsMultipleVoucher: 1 });
    }
    else if (this.mode === 'PartnerPayment') {
      saveApi = this._MasterService.Partner_Payment_Voucher_Save_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId, IsMultipleVoucher: 1 });
    } else if (this.mode === 'PartnerJournalLoanToAccount') {
      saveApi = this._MasterService.Partner_Journal_Voucher_Save_LoantoAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId, IsMultipleVoucher: 1 });
    }

    saveApi.subscribe((res: any) => {
      this.OnCloseVoucher();
      this.onClose();
      this.showSpinner = true;
      if (res[0].CODE > 0) {
        this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].Msg, ...this.configSuccess });
        this.showSpinner = false;

      } else {
        this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].Msg, ...this.configSuccess });
        this.showSpinner = false;
      }
    });
  }

  calculateTranTypeCR() {
    if (this.voucherDetaildata) {
      let sum = 0.00;
      for (let i = 0; i < this.voucherDetaildata.length; i++) {
        sum += Number(this.voucherDetaildata[i]["AmountCR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }

  calculateTranTypeDR() {
    if (this.voucherDetaildata) {
      let sum = 0.00;
      for (let i = 0; i < this.voucherDetaildata.length; i++) {
        sum += Number(this.voucherDetaildata[i]["AmountDR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }

  private resetValidation() {
    this.UIValidationFailed = [];
    this.dataSourceUIValidation = new MatTableDataSource([]);
    this.dataSourceUnmatched = null;
  }

  OnCloseVoucher() {
    $("#voucherDetailModel").modal("hide");
  }

}
